type LinksBlockProps = {
  title?: string;
  links: Array<{
    title: string;
    url: string;
    target?: string;
  }>;
};

const LinksBlock: React.FC<LinksBlockProps> = ({ title, links }) => {
  return (
    <div className="links-block">
      {title && <h2 className="links-block__title h3">{title}</h2>}

      <div className="links-block__grid">
        {links.map((link) => (
          <a href={link.url} target={link.target}>
            {link.title}
          </a>
        ))}
      </div>
    </div>
  );
};

export default LinksBlock;
